import pageMixin from "../mixins/page";
import Axios from "axios";
export default {
  mixins: [pageMixin],
  data: function data() {
    return {
      someText: '',
      pwsd: '',
      startTime: null,
      endTime: null,
      columns: [{
        title: "解码时间",
        sortable: true,
        key: "decode_at",
        width: 200
      }, {
        title: "操作用户",
        sortable: true,
        key: "user_name",
        width: 100
      }, {
        title: "角色",
        sortable: true,
        key: "role_name",
        width: 100
      }, {
        title: "密文",
        sortable: true,
        key: "ciphertext"
      }, {
        title: "明文",
        sortable: true,
        key: "plaintext",
        width: 200
      }, {
        title: "操作类型",
        sortable: true,
        key: "query_type",
        render: function render(h, params) {
          return h('span', params.row.query_type === 0 ? "查询密文对应明文" : "查询密文对应原授权ID");
        },
        width: 160
      }, {
        title: "操作",
        align: 'center',
        width: '100',
        slot: 'btns'
      }],
      logList: [],
      searchUser: null,
      searchType: null,
      userList: [],
      // 开始时间，要小于结束时间，还要小于当前时间
      optionStart: {
        disabledDate: function disabledDate(date) {
          var time;
          if (this === undefined) {
            time = '';
            return;
          } else {
            time = this.endTime ? new Date(this.endTime).valueOf() : '';
            return this.endTime ? date && date.valueOf() > time - 86400000 : date && date.valueOf() > Date.now() - 86400000;
          }
        }
      },
      optionEnd: {
        disabledDate: function disabledDate(date) {
          var time;
          if (this === undefined) {
            time = '';
            return;
          } else {
            time = this.startTime ? new Date(this.startTime).valueOf() : '';
            return date && date.valueOf() < time || date && date.valueOf() > Date.now() - 86400000;
          }
        }
      }
    };
  },
  created: function created() {
    this.getUser();
    this.getLog();
  },
  methods: {
    viewDetails: function viewDetails(row) {
      var _this = this;
      Axios.delete("/pmv5/service/system/oss-tools-log/".concat(row.id, "/")).then(function () {
        return _this.refresh();
      }, function (e) {
        throw e;
      });
    },
    changeUser: function changeUser() {
      this.refresh();
    },
    changeType: function changeType() {
      this.refresh();
    },
    getUser: function getUser() {
      var _this2 = this;
      Axios.get("/pmv5/service/system/simple-users/").then(function (resp) {
        _this2.userList = [];
        _this2.userList = resp.data;
      });
    },
    getLog: function getLog() {
      var _this3 = this;
      var data = {
        page: this.currentPage,
        per_page: this.pageSize,
        user_id: this.searchUser,
        search: this.someText,
        start_time: this.dealTime(this.startTime),
        end_time: this.dealTime(this.endTime)
      };
      if (this.searchType === 0 || this.searchType === 1) {
        data.query_type = this.searchType;
      }
      Axios.post("/pmv5/service/system/oss-tools-log/", data).then(function (resp) {
        _this3.logList = [];
        _this3.logList = resp.data.data;
        _this3.total = resp.data.page_info.count;
      });
    },
    someSearch: function someSearch() {
      this.refresh();
    },
    refresh: function refresh() {
      this.getLog();
    },
    startChange: function startChange() {
      this.refresh();
    },
    endChange: function endChange() {
      this.refresh();
    },
    dealTime: function dealTime(time) {
      if (time) {
        time = this.$moment(time).format('YYYY-MM-DD HH:mm:ss');
      }
      return time;
    }
  }
};